<template>
  <div class="intro__features">
    <div class="intro__features-header">
      <inline-svg class="logo__coverse" src="/images/v4/svg/logo-coverse-color.svg" />
      <inline-svg class="brace brace-large" src="/images/v4/svg/brace_large.svg" />
      <inline-svg class="brace brace-small" src="/images/v4/svg/brace_small.svg" />
    </div>
    <grid :items="grid" />
  </div>
</template>

<script>
import Grid from "@/components/main/partials/Grid.vue";

export default {
  name: 'IntroFeatures',
  components: {
    Grid,
  },
  data() {
    return {
      grid: [{
        icon: '/images/v4/svg/icon-warning.svg',
        title: 'Когда Яндекс и Mail.ru уже&nbsp;не&nbsp;хватает',
        text: 'Преодоление ограничений простых текстовых редакторов и&nbsp;таблиц. Coverse предлагает больше возможностей для организации и&nbsp;контроля.',
      }, {
        icon: '/images/v4/svg/icon-arrows.svg',
        title: 'Когда Notion или Teamly избыточны',
        text: 'Если вам не нужны сложные интерфейсы и&nbsp;перегрузка функционалом — Coverse станет более легким и эффективным решением для менеджмента.',
      }, {
        icon: '/images/v4/svg/icon-persons.svg',
        title: 'Коллаборативные форматы документов',
        text: 'Coverse —  удобные и понятные инструменты для совместной работы, где каждый участник  вносит свой вклад в процесс.',
      }, {
        icon: '/images/v4/svg/icon-position.svg',
        title: 'Оптимизация рабочих процессов',
        text: 'Упрощает управление проектами и задачами, обеспечивая гибкость и нужный уровень детализации без лишней сложности.',
      }],
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/breakpoints";
@import "@/styles/button-primary.scss";

.intro__features {
  max-width: 1000px;
  width: 100%;
  margin: 0 auto;
  padding: 75px 0 0;

  .intro__features-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 19px;
    margin: 0 0 57px;

    .logo__coverse {
      width: 301px;
      height: 57.76772px;
    }

    .brace-large {
      width: 420px;
    }

    .brace-small {
      display: none;
    }
  }
}

@include media-breakpoint-down($size-tablet) {
  .intro__features {
    max-width: 500px;
    padding: 56px 0 0;

    .intro__features-header {
      margin: 0 0 46px;

      .logo__coverse {
        width: 227px;
        height: auto;
        margin-left: -27px;
      }
    }
  }
}

@include media-breakpoint-down($size-mobile) {
  .intro__features {
    max-width: 100%;
    padding: 56px 20px 0;

    .intro__features-header {
      margin: 0 0 33px;
      gap: 13px;

      .logo__coverse {
        width: 165px;
        margin-left: -13px;
      }

      .brace-large {
        display: none;
      }

      .brace-small {
        display: block;
        width: 260px;
      }
    }
  }
}
</style>
